import { render, staticRenderFns } from "./VariableSelector.vue?vue&type=template&id=3648b45c&scoped=true"
import script from "./VariableSelector.vue?vue&type=script&lang=js"
export * from "./VariableSelector.vue?vue&type=script&lang=js"
import style0 from "./VariableSelector.vue?vue&type=style&index=0&id=3648b45c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3648b45c",
  null
  
)

export default component.exports